export function getProductImageUrl(product): string{
  if (product && Array.isArray(product.images) && product.images.length > 0){
    return product.images[0].src;
  }
  return '';
}
